$(document).ready(function() {
    /////// FIND ADDRESS
    if ($('.find-address').length) {
      var $addressList = $('.address-list');
      var $addressContainer = $('.address-container p');

      var $findAddressFieldset = $('.find-address');
      var $findAddressButton = $('.js-find-address');

      var $manualAddressFieldset = $('.manual-address');
      var $showManualAddress = $('.js-show-manual-address');

      var $editAddressButton = $('.address-container .edit-button');
      var addressArray = [];

      $showManualAddress.on('click', function() {
        console.log('eh?');
        $findAddressFieldset.addClass('d-none');
        $manualAddressFieldset.removeClass('d-none');
        $('.manual-address .form-control').each(function() {
          $(this).val('');
        });
      });

      $('.js-show-find-address').on('click', function(e) {
        $manualAddressFieldset.addClass('d-none');
        $findAddressFieldset.removeClass('d-none');
        $showManualAddress.parent().removeClass('d-none');
        $findAddressButton.removeClass('d-none');
        $('.address-list, .address-container').addClass('d-none');
        $('.address-list option:eq(0)').attr('selected', true);
        $('.find-address .form-control option:eq(0)').attr('selected', true);
        $('.manual-address .form-control').each(function() {
          $(this).val('');
          $(this).trigger('change')
        });
      });

      $findAddressButton.on('click', function() {
        $(this).addClass('d-none');
        $addressList.removeClass('d-none');
        formatAddress();
      });

      $editAddressButton.on('click', function() {
        showManualAddress();
      });
    }

    function formatAddress () {
      $addressList.on('change', function() {
        addressArray = $(this).find('option:selected').val().split(',');
        addressArray.unshift($addressContainer.data('name'));
        $addressContainer.empty();
        for (i=0; i<addressArray.length; i++) {
          $addressContainer.append(addressArray[i].trim()+'\n');
        }
        $addressContainer.parent().removeClass('d-none');
        $showManualAddress.parent().addClass('d-none');
        dummyPopulateAddressFields();
      });
    }
    function showManualAddress() {
      $findAddressFieldset.addClass('d-none');
      $manualAddressFieldset.removeClass('d-none');
    }

    ////// REMOVE THIS FUNCTION FOR PROD - JUST DUMMY ARRAY DATA /////////
    function dummyPopulateAddressFields() {
      var addressArray = ['123', 'Golf Road', 'Swanwick', 'Derbyshire', 'DE55 8FT'];
      $('.manual-address .form-control').each(function(index) {
          $(this).val(addressArray[index]);
          $(this).trigger('change')
      });
    }
    //////////////////////////////////////////////////////////////////////
  });
